import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { authApi } from "@/api/auth";
import { useAuthStore } from "@/stores/auth";
import { AppRouter } from "./router";

export function App() {
  const { accessToken, setAccessToken, setMe } = useAuthStore();

  // Refresh silencioso al boot si no tenemos access pero sí cookie de refresh.
  useEffect(() => {
    if (accessToken) return;
    authApi
      .refresh()
      .then((t) => setAccessToken(t.access_token))
      .catch(() => {
        /* sin cookie válida, queda como no logueado */
      });
  }, [accessToken, setAccessToken]);

  // Cargar /me cuando hay token.
  const meQuery = useQuery({
    queryKey: ["me"],
    queryFn: authApi.me,
    enabled: Boolean(accessToken),
  });

  useEffect(() => {
    if (meQuery.data) setMe(meQuery.data);
  }, [meQuery.data, setMe]);

  return <AppRouter />;
}
